/**
 * IXD/DSD 비교 페이지 스토어 Provider
 * 페이지 진입 시 스토어 인스턴스를 생성하고, 하위에서 useIxdDsdCompareStore 사용 가능하게 합니다.
 */

import { useRef } from "react";
import {
  createIxdDsdCompareStore,
  IxdDsdCompareStoreContext,
} from "@/stores/ixd-dsd-compare";

export const IxdDsdCompareStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const storeRef = useRef<ReturnType<typeof createIxdDsdCompareStore> | null>(
    null,
  );
  if (!storeRef.current) {
    storeRef.current = createIxdDsdCompareStore();
  }
  const store = storeRef.current;

  return (
    <IxdDsdCompareStoreContext.Provider value={store}>
      {children}
    </IxdDsdCompareStoreContext.Provider>
  );
};
